<app-assignement-price-coef-grid
    permissionKey="list"
></app-assignement-price-coef-grid>
